/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useLayoutEffect as o}from"react";const l=Boolean(null===globalThis||void 0===globalThis?void 0:globalThis.document)?o:()=>{};export{l as useLayoutEffect};
//# sourceMappingURL=index.js.map
